/**
 * Layout principal avec Sidebar verticale
 */

import { useState, ReactNode } from 'react';
import { ChatWidgetLauncher } from '@e-store/shared';
import { Sidebar } from './Sidebar';
import './LayoutWithSidebar.css';

interface LayoutWithSidebarProps {
  children: ReactNode;
}

export function LayoutWithSidebar({ children }: LayoutWithSidebarProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="app-layout">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onCollapsedChange={setSidebarCollapsed}
      />

      <div className={`app-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {/* Topbar avec hamburger */}
        <header className="app-topbar">
          <button
            className="hamburger-btn"
            onClick={() => setSidebarOpen(true)}
            aria-label="Ouvrir le menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <h2 className="app-topbar-title">E-Store BackOffice</h2>
        </header>

        {/* Contenu principal */}
        <main className="app-content">{children}</main>
      </div>

      {/* Chatbot guide utilisateur */}
      <ChatWidgetLauncher context="backoffice" />
    </div>
  );
}
